module.exports = __webpack_public_path__ + "static/media/acoustic-acousticbreeze.87e6bd67.mp3";